export const isLuciaColetaAtivada = (flag) => flag !== false && flag !== 0 && flag !== '0';
